// extracted by mini-css-extract-plugin
export var cookiesSection = "fc_Kk";
export var cookiesSection__btn = "fc_Kn";
export var cookiesSection__link = "fc_Km";
export var cookiesSection__text = "fc_Kl";
export var cookiesSection__wrapper = "fc_Kj";